import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  apiBaseUrl: 'https://doublonsbuster-internal.rec.finzzle-groupe.com/api',
  proxeemaBackofficeUrl: 'https://proxeema-backoffice.rec.finzzle-groupe.com',
  auth: {
    clientId: '89f0cff5-8709-4085-9a08-b67c0a277d10',
    authority: 'https://login.microsoftonline.com/5a481998-953d-4069-a079-758e4f7cab47',
    knownAuthorities: ['login.microsoftonline.com'],
    apiScope: 'api://275374b4-2a0c-4f50-9768-3af3046afb26/User.APIAccess'
  }
};
